import React from "react";
import { LcmModel } from "../../domain/LcmModel";
import { AddCounselDialog } from "./dialogs/AddCounselDialog";
import { DialogType, EntityDialog } from "./types";
import { AddTimeRecordDialog } from "./dialogs/AddTimeRecordDialog";
import { AddCaseNoteDialog } from "./dialogs/CaseNoteDialog";
import { AttachEmailDialog } from "./dialogs/AttachEmailDialog";
import { InternalMessageDialog } from "./dialogs/InternalMessageDialog";
import { CloseCaseDialog } from "./dialogs/CloseCaseDialog";
import { FutureEventDialog } from "./dialogs/FutureEventDialog";
import { OptionsMenu } from "./OptionsMenu";
import { ReopenCaseDialog } from "./dialogs/ReopenCaseDialog";
import {UpdatedDialog} from "./dialogs/UpdatedDialog";
import {Activity} from "@ofqual/portal-activity-feed";

type RenderDialogProps = {
    focusedEntity: EntityDialog | null;
    onClose: () => void;
    lcmItem: LcmModel;
    setFocusedEntity: (value: React.SetStateAction<EntityDialog | null>) => void;
};

export const RenderDialog: React.FC<RenderDialogProps> = ({
    focusedEntity,
    onClose,
    lcmItem,
    setFocusedEntity
}) => {
    if (!focusedEntity) return null;
    const { dialogType } = focusedEntity;
    const focusedActivity = focusedEntity.focusedActivity as Activity;
    switch (dialogType) {
        case DialogType.AddExternalCounsel:
            return <AddCounselDialog onClose={onClose} lcmItem={lcmItem} />;
        case DialogType.AddTimeRecord:
            return <AddTimeRecordDialog onClose={onClose} lcmItem={lcmItem} />;
        case DialogType.AddCaseNote:
            return <AddCaseNoteDialog onClose={onClose} lcmItem={lcmItem} />;
        case DialogType.AttachmentEmail:
            return <AttachEmailDialog onClose={onClose} lcmItem={lcmItem} />;
        case DialogType.AddInternalMessage:
            return <InternalMessageDialog onClose={onClose} lcmItem={lcmItem} />;
        case DialogType.CloseCase:
            return <CloseCaseDialog onClose={onClose} lcmItem={lcmItem} />;
        case DialogType.FutureEvent:
            return <FutureEventDialog onClose={onClose} lcmItem={lcmItem} />;
        case DialogType.ReopenCase:
            return <ReopenCaseDialog onClose={onClose} lcmItem={lcmItem} />; 
        case DialogType.OptionMenuEvent:
            return <OptionsMenu lcmItem={lcmItem} dialogType={dialogType} setFocusedEntity={setFocusedEntity} />;
        case DialogType.LcmChanged:
            return <UpdatedDialog activity={focusedActivity} onClose={onClose} />;
        default:
            return null;
    }
};
